<div class="modal-container">
  <div class="header">
    <div class="header-container">
      <div class="header-copy-container">
        <span class="header-copy">Search</span>
        <button
          class="button-close blank-button"
          merriNoFocusLink
          (click)="onCloseClick()"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
      <app-visionboard-global-search-search-input
        [searchTerm]="searchTerm"
        (keywordSearch)="onSearch($event)"
      ></app-visionboard-global-search-search-input>
    </div>
  </div>
  <div class="body merri-scrollbar-gray">
    <div class="body-container">
      <app-visionboard-global-search-result
        (resultSelect)="onGlobalSearchResultSelect($event)"
        [itemCustomAddRemoveTemplate]="input.itemCustomAddRemoveTemplate"
        [forceVisionboardItemAddRemoveButton]="input.forceVisionboardItemAddRemoveButton"
        [source]="input.source"
      ></app-visionboard-global-search-result>
    </div>
  </div>
</div>
